import { setParameterValue } from "./set-parameter-value";
import { SelectedTier } from "../models/app";

/**
 * Appends tier query string parameters to the href attribute of an HTMLLinkElement.
 * @param linkElement The HTMLLinkElement to append params to.
 * @param pageTier The tier params to apply.
 */
export function appendTierQueryParams(linkElement: HTMLLinkElement, pageTier: SelectedTier):void {
	const href: string = linkElement.getAttribute("href") ?? "";

	if (href) {
		// build new URL to conveniently apply the tier parameter IDs
		let url = new URL(href, linkElement.baseURI);
		let params = new URLSearchParams(url.search);

		// set tier parameters on the query string
		setParameterValue(params, "tier1", pageTier?.group?.id);
		setParameterValue(params, "tier2", pageTier?.branch?.id);
		setParameterValue(params, "tier3", pageTier?.broker?.id);

		url.search = params.toString();

		// set href attribute
		linkElement.setAttribute("href", url.toString());
	}
}